import { PAGE_REQUEST } from 'store/app/actions';

import { types } from './actions';

const initialState = {
  isOpen: false,
};

const reducer = (state = initialState, action) => {
  const { type } = action;

  switch (type) {
    case PAGE_REQUEST:
      return initialState;
    case types.CLOSE:
      return {
        ...state,
        isOpen: false,
      };
    case types.OPEN:
      return {
        ...state,
        isOpen: true,
      };

    default:
      return state;
  }
};

export default reducer;

const getScope = (state) =>
  state.modules.settings.company.downloadCuiAuditCsvDrawer;

export const getIsOpen = (state) => getScope(state).isOpen;
